<template>
  <div>
  <component :is="user === undefined ? 'div' : 'b-card'">
    
    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="user === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-users-list'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>
    <div v-if="user">
      <!-- Alert: Not verify -->
       <div
        v-if="type === 'influencer' && (!user.email || user.email_status === 'no_email')">
        <b-alert
          variant="danger"
          show
        >
          <h4 class="alert-heading">
            Kullanıcının e-posta adresi tanımlanmamış.
            <b-button 
            class="ml-2"
            variant="success"
            size="sm"
            @click="$refs.account.openChangeEmailModal()"
          >
            <FeatherIcon icon="SendIcon"  />
            Mail Ekle
          </b-button>
          </h4>
          
        </b-alert>

      </div>
      <div v-if="user.verify == false && user.email">
      
      <b-alert
        variant="danger"
        show
      >
        <h4 class="alert-heading">
          Kullanıcının kaydı tamamlanmamış. E-posta doğrulaması bekleniyor.
          <b-button 
          class="ml-2"
          variant="success"
          size="sm"
          @click="reSendMail(user.email)"
        >
          <FeatherIcon icon="SendIcon"  />
          Mail gönder
        </b-button>
        </h4>
        
      </b-alert>
      </div>
    </div>
    <b-tabs
      v-if="user"
      pills
    >

      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Hesap</span>
        </template>
        <user-edit-tab-account
          :user="user"
          :type="type"
          class="mt-2 pt-75"
          ref="account"
          @email-changed="fetchEmailHistory(); getUser()"
        />
      </b-tab>

      <!-- Tab: Information -->
      <b-tab>
        <template #title>
          <feather-icon
            icon="InfoIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Bilgiler</span>
        </template>
        <user-edit-tab-information class="mt-2 pt-75" />
      </b-tab>

      <!-- Tab: Social -->
      <b-tab v-if="type=='admin'">
        <template #title>
          <feather-icon
            icon="Sha2Icon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">İzinler</span>
        </template>
        <permissions-selector v-model="user.permissions"  />
      </b-tab>
    </b-tabs>
    <b-row class="mt-2" v-if="!isFenomen">
        <b-col>
          <b-button
            variant="outline-secondary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            @click="$router.go(-1)"
          >
          <feather-icon
              icon="leftArrow"
              size="18"
              
            />
            Geri
          </b-button>
          <b-button
            variant="primary"
            @click="updateUser"
          >
            Güncelle
          </b-button>
        </b-col>
      </b-row>
  </component>

  <b-card v-if="emailHistory && emailHistory.length > 0">
    <!-- Email Change History -->
      <b-row>
        <b-col cols="12">
          <h6 class="text-primary mb-2">
            <feather-icon icon="ClockIcon" size="16" class="mr-50" />
            Email Değişiklik Geçmişi
          </h6>
          <b-table
            :items="emailHistory"
            :fields="emailHistoryFields"
            responsive
            small
            striped
            hover
          >
            <template #cell(change_date)="data">
              {{ formatDate(data.item.change_date) }}
            </template>
            <template #cell(changed_by)="data">
              <b-badge variant="light-primary">
                {{ data.item.new_email }}
              </b-badge>
            </template>
          </b-table>
        </b-col>
      </b-row>
  </b-card>
  </div>
</template>
<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BButton, BIcon,
  BRow,
  BCol,
  BTable,
} from 'bootstrap-vue'
import { ref, onUnmounted, onMounted, computed, watch } from '@vue/composition-api'
import router from '@/router'
import UserEditTabAccount from './UserEditTabAccount.vue'
import UserEditTabInformation from './UserEditTabInformation.vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axiosIns from '@/axios'
import PermissionsSelector from '@/components/user/PermissionsSelector.vue'
import store from '@/store'

export default {
  components: {
    BTab,
    BRow,
    BCol,
    BTabs,
    BCard,
    BAlert,
    BLink,
    BButton,

    UserEditTabAccount,
    UserEditTabInformation,
    PermissionsSelector,
    BTable
  },
  data(){
    return{
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'email', label: 'Mail' },
        { key: 'created_date', label: 'Kayıt Tarihi' },
      ],
    }
  },
  setup() {
    const toast = useToast()

    const user = ref(null)
    const type = ref(null)
    const saving = ref(false)
    const userLoggers = ref([])

    
    const emailHistory = ref([])
    const emailHistoryFields = [
      { key: 'change_date', label: 'Değişiklik Tarihi', sortable: true },
      { key: 'old_email', label: 'Eski Email', sortable: true },
      { key: 'new_email', label: 'Yeni Email', sortable: true },
    ]


    const routeName = router.currentRoute.name
    type.value = routeName.includes('admin') ? 'admin' : 'influencer'

    const reSendMail = (email) => {
      axiosIns.post('/auth/resend-verification-mail', { email })
        .then(res => {
          if (res.data.success) {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'CheckCircleIcon',
                variant: 'success',
                title: res.data.message,
              },
            })
          } else {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                title: res.data.error || 'Mail gönderilemedi',
              },
            })
          }
        })
        .catch(() => {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                title: 'Bir hata oluştu',
              },
            })
        })
    }

    const getUser = () => {
      axiosIns.get(`/user`, {
        params: {
          id: router.currentRoute.params.id,
          user_type: type.value
        }
      })
      .then(response => { 
        const userData = response.data.data[0];
        user.value = {
          ...userData,
          permissions: [...userData.permissions || []], // referans değiştir
          // Influencer alanları için varsayılan değerler
          link_ici_odeme_orani: userData.link_ici_odeme_orani || null,
          link_disi_odeme_orani: userData.link_disi_odeme_orani || null,
          payment_amount: userData.payment_amount || null,
          vesting_period: userData.vesting_period || 14,
          is_maintenance: userData.is_maintenance !== undefined ? userData.is_maintenance : false,
          // Email durumu kontrolü
          email_status: userData.email_status || (userData.email ? 'normal' : 'no_email'),
          has_email: userData.has_email !== undefined ? userData.has_email : !!userData.email
        };
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          user.value = undefined
          
        }
        toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            title: 'Kullanıcı bilgileri alınamadı',
          },
        })
      })
    }

    
    // Email geçmişini getir
    const fetchEmailHistory = () => {
      axiosIns.get('/user/email-history', {
        params: {
          id: router.currentRoute.params.id,
          user_type: type.value
        }
      })
      .then(response => {
        if (response.data.success) {
          emailHistory.value = response.data.data
        }
      })
      .catch(error => {
        console.error('Email geçmişi alınamadı:', error)
      })
    }


    const updateUser = () => {
      if (!user.value) return
      
      saving.value = true
      
      // Güncellenecek veriler
      const updateData = {
        id: user.value.id,
        user_type: type.value,
        name_surname: user.value.name_surname,
        phone: user.value.phone,
        is_maintenance: user.value.is_maintenance ? 1 : 0
      }

      // Email kontrolü - no_email durumunu handle et
      if (user.value.email && user.value.email_status !== 'no_email') {
        updateData.email = user.value.email
      }

      // Influencer için ek alanlar
      if (type.value === 'influencer') {
        updateData.username = user.value.username
        updateData.use_system_date = user.value.use_system_date || null
        updateData.link_ici_odeme_orani = user.value.link_ici_odeme_orani || null
        updateData.link_disi_odeme_orani = user.value.link_disi_odeme_orani || null
        updateData.payment_amount = user.value.payment_amount || null
        updateData.vesting_period = user.value.vesting_period || 14
      }

      // Admin için permissions
      if (type.value === 'admin' && user.value.permissions) {
        updateData.permissions = user.value.permissions
      }

      axiosIns.put(`/user`, updateData)
      .then(response => { 
        if (response.data.success) {
          // Güncellenen kullanıcı verisi varsa al
          if (response.data.data) {
            user.value = {
              ...user.value,
              ...response.data.data,
              permissions: [...(response.data.data.permissions || [])],
            }
          }
          
          toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              icon: 'CheckCircleIcon',
              variant: 'success',
              title: response.data.message || 'Kullanıcı başarıyla güncellendi',
            },
          })
        } else {
          toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              title: response.data.error || 'Güncelleme başarısız',
            },
          })
        }
      })
      .catch(error => {
        console.error("Güncelleme sırasında bir hata oluştu:", error);
        
        let errorMessage = 'Güncelleme sırasında bir hata oluştu'
        
        if (error.response) {
          if (error.response.status === 404) {
            errorMessage = 'Kullanıcı bulunamadı'
            user.value = undefined
          } else if (error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error
          }
        }
        
        toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            title: errorMessage,
          },
        })
      })
      .finally(() => {
        saving.value = false
      })
    }

    

    // Validasyon watchers
    const setupValidationWatchers = () => {
      // Vesting period kontrolü
      watch(() => user.value?.vesting_period, (newVal) => {
        if (newVal !== null && newVal !== undefined) {
          if (newVal < 1) user.value.vesting_period = 1
          if (newVal > 365) user.value.vesting_period = 365
        }
      })
      
      // Link içi ödeme oranı kontrolü
      watch(() => user.value?.link_ici_odeme_orani, (newVal) => {
        if (newVal !== null && newVal !== undefined) {
          if (newVal < 0) user.value.link_ici_odeme_orani = 0
          if (newVal > 100) user.value.link_ici_odeme_orani = 100
        }
      })
      
      // Link dışı ödeme oranı kontrolü
      watch(() => user.value?.link_disi_odeme_orani, (newVal) => {
        if (newVal !== null && newVal !== undefined) {
          if (newVal < 0) user.value.link_disi_odeme_orani = 0
          if (newVal > 100) user.value.link_disi_odeme_orani = 100
        }
      })
    }

    onMounted(() => {
      getUser()
      setupValidationWatchers()
      if(!store.getters['user/isFenomen']){
        fetchEmailHistory()
      }
    })
    
    // Tarih formatlama
    const formatDate = (dateString) => {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return new Intl.DateTimeFormat('tr-TR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(date)
    }


    return {
      user,
      type,
      userLoggers,
      saving,
      emailHistory,
      emailHistoryFields,
      updateUser,
      fetchEmailHistory,
      getUser,
      formatDate,
      reSendMail
    }
  }
}
</script>

<style>
</style>

<style>

</style>
